const getIPFromVORE = async () => {
    try {
        const response = await fetch(`https://api.vore.top/api/IPdata`);
        const {code, msg, ipinfo, ipdata} = await response.json();
        if(code == 200 && msg == 'SUCCESS' && ipdata.info3) {
            return {
                ip: ipinfo.text,
                country: ipdata.country || '中国',
                province: ipdata.info1 || '',
                city: ipdata.info2 || '',
                area:ipdata.info3 || '',
                isp: ipdata.isp ? '中国' + ipdata.isp : '',
            }
        }
    } catch (error) {
        console.error("Error fetching IP from vore:", error);
    }
};

export { getIPFromVORE };